import { Box, type SxProps, type SystemStyleObject, type Theme } from '@mui/system';
import type React from 'react';

interface IndentedSectionProps {
  children: React.ReactNode;
  customColor?: string;
  dataTest?: string;
  sx?: SxProps<Theme>;
}

const defaultStyles = (customColor?: string): SystemStyleObject<Theme> => ({
  '&:before': {
    bgcolor: customColor ?? 'action.disabled',
    content: '""',
    height: '100%',
    left: 0,
    position: 'absolute',
    top: 0,
    width: '2px',
  },
  marginBottom: 0,
  marginTop: 1,
  paddingLeft: 1.5,
  position: 'relative',
});

export const IndentedSections = ({ children, customColor, dataTest = '', sx }: IndentedSectionProps) => {
  return (
    <Box
      sx={[defaultStyles(customColor), ...(Array.isArray(sx) ? sx : sx ? [sx] : [])] as SxProps<Theme>}
      data-test={dataTest}
    >
      {children}
    </Box>
  );
};
